export const adminTokenStorageKey = "partfinder.admin.token";

export const getAdminToken = () => localStorage.getItem(adminTokenStorageKey);

export const setAdminToken = (token: string) => {
  localStorage.setItem(adminTokenStorageKey, token);
};

export const clearAdminToken = () => {
  localStorage.removeItem(adminTokenStorageKey);
};
